// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root { 
--white_A700_7f:#ffffff7f; 
--black_900_7f:#0000007f; 
--black_900_b2:#000000b2; 
--cyan_900_ab:#135f76ab; 
--red_600:#e04243; 
--deep_purple_600:#4f3cc9; 
--green_700:#279044; 
--cyan_900_19:#135f7619; 
--black_900_3f:#0000003f; 
--green_300_19:#91ba8319; 
--teal_300:#4890a6; 
--white_A700_99:#ffffff99; 
--cyan_900_0c:#135f760c; 
--black_900_00:#00000000; 
--white_A700_ab:#ffffffab; 
--teal_900:#0a3b49; 
--deep_orange_300:#ff8b6a; 
--blue_gray_900:#2d2d2d; 
--red_A700:#fc040a; 
--teal_A700:#00b59b; 
--gray_600:#6d6d6e; 
--blue_gray_100:#d9d9d9; 
--amber_300:#ffc85f; 
--black_900_0c:#0000000c; 
--orange_200:#eebc74; 
--gray_100_02:#f7f7f7; 
--indigo_400:#5564d7; 
--black_900_99:#00000099; 
--gray_100_01:#f2f2f6; 
--black_900_19:#00000019; 
--white_A700:#ffffff; 
--cyan_900_33:#135f7633; 
--gray_50:#f8f8f8; 
--white_A700_33:#ffffff33; 
--black_900_66:#00000066; 
--black_900:#000000; 
--gray_500_01:#a6a5a5; 
--blue_gray_800:#3e4756; 
--deep_orange_400:#ff6652; 
--gray_700_99:#5d5a6f99; 
--gray_700:#5d5a6f; 
--blue_gray_200:#c0c7d0; 
--gray_500:#9a9a9a; 
--gray_600_01:#7f8284; 
--blue_gray_400:#828fa2; 
--indigo_50:#e2e8ed; 
--gray_900_00:#0a023c00; 
--gray_900:#0a033c; 
--cyan_900_7c:#135f767c; 
--blue_gray_800_01:#36414f; 
--gray_300:#dedde4; 
--gray_100:#f2f2f6; 
--white_A700_00:#ffffff00; 
--cyan_900_3f:#135f763f; 
--black_900_33:#00000033; 
--cyan_900_7f:#135f767f; 
--cyan_900:#135f76; 
}`, "",{"version":3,"sources":["webpack://./src/styles/color.css"],"names":[],"mappings":"AAAA;AACA,yBAAyB;AACzB,wBAAwB;AACxB,wBAAwB;AACxB,uBAAuB;AACvB,iBAAiB;AACjB,yBAAyB;AACzB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,wBAAwB;AACxB,kBAAkB;AAClB,yBAAyB;AACzB,uBAAuB;AACvB,wBAAwB;AACxB,yBAAyB;AACzB,kBAAkB;AAClB,yBAAyB;AACzB,uBAAuB;AACvB,kBAAkB;AAClB,mBAAmB;AACnB,kBAAkB;AAClB,uBAAuB;AACvB,mBAAmB;AACnB,wBAAwB;AACxB,oBAAoB;AACpB,qBAAqB;AACrB,oBAAoB;AACpB,wBAAwB;AACxB,qBAAqB;AACrB,wBAAwB;AACxB,oBAAoB;AACpB,uBAAuB;AACvB,iBAAiB;AACjB,yBAAyB;AACzB,wBAAwB;AACxB,mBAAmB;AACnB,qBAAqB;AACrB,uBAAuB;AACvB,yBAAyB;AACzB,uBAAuB;AACvB,kBAAkB;AAClB,uBAAuB;AACvB,kBAAkB;AAClB,qBAAqB;AACrB,uBAAuB;AACvB,mBAAmB;AACnB,uBAAuB;AACvB,kBAAkB;AAClB,uBAAuB;AACvB,0BAA0B;AAC1B,kBAAkB;AAClB,kBAAkB;AAClB,yBAAyB;AACzB,uBAAuB;AACvB,wBAAwB;AACxB,uBAAuB;AACvB,kBAAkB;AAClB","sourcesContent":[":root { \n--white_A700_7f:#ffffff7f; \n--black_900_7f:#0000007f; \n--black_900_b2:#000000b2; \n--cyan_900_ab:#135f76ab; \n--red_600:#e04243; \n--deep_purple_600:#4f3cc9; \n--green_700:#279044; \n--cyan_900_19:#135f7619; \n--black_900_3f:#0000003f; \n--green_300_19:#91ba8319; \n--teal_300:#4890a6; \n--white_A700_99:#ffffff99; \n--cyan_900_0c:#135f760c; \n--black_900_00:#00000000; \n--white_A700_ab:#ffffffab; \n--teal_900:#0a3b49; \n--deep_orange_300:#ff8b6a; \n--blue_gray_900:#2d2d2d; \n--red_A700:#fc040a; \n--teal_A700:#00b59b; \n--gray_600:#6d6d6e; \n--blue_gray_100:#d9d9d9; \n--amber_300:#ffc85f; \n--black_900_0c:#0000000c; \n--orange_200:#eebc74; \n--gray_100_02:#f7f7f7; \n--indigo_400:#5564d7; \n--black_900_99:#00000099; \n--gray_100_01:#f2f2f6; \n--black_900_19:#00000019; \n--white_A700:#ffffff; \n--cyan_900_33:#135f7633; \n--gray_50:#f8f8f8; \n--white_A700_33:#ffffff33; \n--black_900_66:#00000066; \n--black_900:#000000; \n--gray_500_01:#a6a5a5; \n--blue_gray_800:#3e4756; \n--deep_orange_400:#ff6652; \n--gray_700_99:#5d5a6f99; \n--gray_700:#5d5a6f; \n--blue_gray_200:#c0c7d0; \n--gray_500:#9a9a9a; \n--gray_600_01:#7f8284; \n--blue_gray_400:#828fa2; \n--indigo_50:#e2e8ed; \n--gray_900_00:#0a023c00; \n--gray_900:#0a033c; \n--cyan_900_7c:#135f767c; \n--blue_gray_800_01:#36414f; \n--gray_300:#dedde4; \n--gray_100:#f2f2f6; \n--white_A700_00:#ffffff00; \n--cyan_900_3f:#135f763f; \n--black_900_33:#00000033; \n--cyan_900_7f:#135f767f; \n--cyan_900:#135f76; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
